function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "37",
  viewBox: "0 0 29 37",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "moon-path",
  d: "M0 0h29v37H0z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#moon-path"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.003 17.337c-.66 8.477 5.947 15.56 14.19 15.56.452 0 .901-.02 1.346-.066.436-.04.632.531.274.787A18.03 18.03 0 0118.29 37C7.767 37-.683 28.009.044 17.206.654 8.09 7.944.696 16.954.05a18.04 18.04 0 0111.862 3.333c.358.256.156.825-.283.784a14.044 14.044 0 00-4.439.28C18.042 5.8 13.488 11.088 13.003 17.337",
  fill: "currentColor",
  mask: "url(#mask-2)"
}))));